enum ShortMonthHandlingType {
    LastDayOfMonth = "LAST_DAY_OF_MONTH",
    FirstDayOfMonth = "FIRST_DAY_OF_MONTH"
}
export default ShortMonthHandlingType